export const MY_TELESCOPE_PRIVACY_POLICY_LINK =
  "https://www.mytelescope.io/privacy-policy" as const;
export const MY_TELESCOPE_TERMS_AND_CONDITIONS_LINK =
  "https://www.mytelescope.io/terms-and-conditions" as const;
